<footer class="footer">
  <div class="container foo-top">
    <div class="logoDiv">
      <a routerLink="/" class="logo">
        <img src="assets/images/Logo ver 2.png" alt="Radwa Khallaf" />
      </a>
    </div>

    <div class="row">
      <!-- Navigation -->
      <div class="col-md-2 col-sm-6 col-6">
        <div class="widget widget-navigation">
          <h6 class="widget-title">{{ 'footer.nav' | translate }}</h6>
          <ul>
            <li><a (click)="onActivate()" routerLinkActive="active" routerLink="/home">{{ 'nav.home' | translate }}</a></li>
            <li><a routerLinkActive="active" routerLink="/about">{{ 'nav.about' | translate }}</a></li>
            <li><a routerLinkActive="active" routerLink="/categories">{{ 'nav.categories' | translate }}</a></li>
            <li><a routerLinkActive="active" routerLink="/packges">{{ 'nav.packages' | translate }}</a></li>
            <li><a routerLinkActive="active" routerLink="/shop">{{ 'nav.shop' | translate }}</a></li>
            <li><a routerLinkActive="active" routerLink="/blogs">{{ 'nav.journal' | translate }}</a></li>
          </ul>
        </div>
      </div>

      <!-- Account -->
      <div class="col-md-2 col-sm-6 col-6">
        <div class="widget widget-navigation">
          <h6 class="widget-title">{{ 'footer.account' | translate }}</h6>
          <ul>
            <li><a routerLink="/login">{{ 'nav.signin' | translate }}</a></li>
            <li><a routerLink="/sign_up">{{ 'nav.register' | translate }}</a></li>
            <li><a routerLink="/user_profile">{{ 'footer.orders' | translate }}</a></li>
            <li><a routerLink="/shop_cart">{{ 'footer.cart' | translate }}</a></li>
          </ul>
        </div>
      </div>

      <!-- Contact -->
      <div class="col-md-3 col-sm-6">
        <div class="widget">
          <h6 class="widget-title">{{ 'footer.contact' | translate }}</h6>
          <ul class="widget-navigation">
            <li><a href="tel:+01011419115">+01011419115</a></li>
            <li><a href="mailto:support&#64;radwakhallaf.com">support&#64;radwakhallaf.com</a></li>
          </ul>
        </div>
      </div>

      <!-- Social -->
      <div class="col-md-3 offset-md-1 col-sm-6">
        <div class="widget widget-social">
          <h6 class="widget-title">{{ 'footer.follow' | translate }}</h6>
          <div class="social-media">
            <a target="_blank"
               (mouseenter)="groupFb = true" (mouseleave)="groupFb = false"
               href="https://www.facebook.com/groups/648946182371633">
              @if (groupFb) { <span class="groupFb">FB Group</span> }
              <img src="assets/images/social/face.png" alt="Facebook Group">
            </a>

            <a target="_blank"
               (mouseenter)="groupPage = true" (mouseleave)="groupPage = false"
               href="https://www.facebook.com/profile.php?id=100076438811752">
              @if (groupPage) { <span class="groupPage">FB Page</span> }
              <img src="assets/images/social/face.png" alt="Facebook Page">
            </a>

            <a target="_blank" href="https://www.instagram.com/radwakhallaf_reviews/">
              <img src="assets/images/social/insta.png" alt="Instagram">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <p class="copyright">{{ 'footer.copyright' | translate }}</p>
  </div>
</footer>
